import React from 'react';
import styles from './Textarea.module.css';

const Textarea = ({ 
  label,
  value, 
  onChange, 
  placeholder, 
  rows = 4, 
  maxLength,
  disabled = false,
  className,
  required,
  id,
  name,
  ...props 
}) => {
  return (
    <div className={styles.textareaWrapper}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <textarea
        id={id}
        name={name}
        className={`${styles.textarea} ${className || ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
        {...props}
      />
      {maxLength && (
        <div className={styles.charCount}>
          {value?.length || 0}/{maxLength}
        </div>
      )}
    </div>
  );
};

export default Textarea; 